import DefaultDialog from './DefaultDialog';

export default DefaultDialog;
